import {Component, OnInit} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import { UmsaetzeInternetAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'common-ui-umsaetze-internet',
    templateUrl: './umsaetze-internet.component.html',
    styleUrls: ['./umsaetze-internet.component.scss']
})
export class UmsaetzeInternetComponent extends FormBaseComponent<UmsaetzeInternetAngaben> implements OnInit {

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                protected readonly translateService: TranslateService) {
        super(messageService);
    }

    public clearElektronischeSchnitstelle($event: unknown): void {
        if (!$event) {
            this.data.marktplaetze = [];
        }
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (!this.data.marktplaetze) {
            this.data.marktplaetze = [];
        }
    }

    public addMarktplatz(): void {
        this.data.marktplaetze.push({});
    }

    public removeMarktplatz(index: number): void {
        this.data.marktplaetze.splice(index, 1);
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            eigenerWebshop: [this.data.eigenerWebshop],
            eigenerWebshopUrl: [this.data.eigenerWebshopUrl, [
                this.validatorService.maxLength(128)
            ]],
            handelMarktplatz: [this.data.handelMarktplatz]
        });
    }
}
